import React from 'react';

import baseStyles from '../Mission1000/styles';
import styles from './styles';
import { withResizer } from '../../../HoCs';
import { EVENT_CATEGORIES, EVENT_ACTIONS } from '../../../services/Analytics';
import { Mission1000 } from '../Mission1000';
import { merge } from '../../../utils';
import { guc } from '../../../services/Localisation';
import SimpleHeader from '../../../ui-components/Header/Simple';
import Footer from '../../../ui-components/Footer';
import view from '../../../Enums';
import Facebook from '../../../resources/vectors/Facebook';
import Instagram from '../../../resources/vectors/Instagram';
import Linkedin from '../../../resources/vectors/Linkedin';
import Twitter from '../../../resources/vectors/Twitter';
import Youtube from '../../../resources/vectors/Youtube';

class Staycation extends Mission1000 {

    content_json_key = 'staycation_content_json';
    pageEventCaterogy = EVENT_CATEGORIES.STAYCATION_PAGE;
    styles = merge(baseStyles, styles);

    state = this.parseJsonString();

    headerActions = undefined;
    footerLinks = [
        { content: guc('list_my_property'), href: '/', event_action: EVENT_ACTIONS.HOME_PAGE_LINK_CLICKED },
        { content: guc('abt_oyo'), href: guc('abt_oyo_link'), target: '_blank', event_action: EVENT_ACTIONS.ABOUT_OYO_CLICKED },
    ];

    renderHeader = () => <SimpleHeader actions={this.headerActions} homeLinkLabel={guc('list_my_property')} disableHomeLink={this.getViewMode() == view.MOBILE} />;

    renderFooter = () => {
        const socialLinks = [
            { href: guc('facebook_link'), Icon: Facebook }, { href: guc('twitter_link'), Icon: Twitter },
            { href: guc('instagram_link'), Icon: Instagram }, { href: this.state.data.youtube_link, Icon: Youtube },
            { href: guc('linkedin_link'), Icon: Linkedin },
        ];
        return <Footer links={this.footerLinks} socialLinks={socialLinks} />;
    }

}

export default withResizer(Staycation);